import { Descriptions, Modal } from 'antd'
import { get } from 'lodash'
import React from 'react'

function DeliveryStopsModal(props) {
  const { visible, line } = props

  const location = get(line, 'location')
  return (
    <Modal visible={visible} title={'Package Stops'} destroyOnClose={true} width={'75%'}>
      <Descriptions title="Stop Details" bordered style={{ marginBottom: 20 }} column={4}>
        <Descriptions.Item label="Country">{get(location, 'country')}</Descriptions.Item>
        <Descriptions.Item label="Location">{get(location, 'location')}</Descriptions.Item>
        <Descriptions.Item label="Address">{get(location, 'address.label')}</Descriptions.Item>
      </Descriptions>
      line
    </Modal>
  )
}

DeliveryStopsModal.propTypes = {}
DeliveryStopsModal.defaultProps = {}

export default DeliveryStopsModal
